import React from "react";
import UserProfileCard from "../UserProfileCard";

function UserData() {
  return (
    <>
      <div className="bg-[#fff] p-4 my-1 w-full shadow-md rounded-md flex items-center gap-x-3 gap-y-1">
        <div className="cursor-pointer overflow-hidden w-12 rounded-full flex items-center justify-center">
          <img
            src="assets/images/user/user-3.jpg"
            alt="User Image"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="flex items-center justify-between flex-wrap-reverse font-semibold text-[#666666] w-full gap-x-4">
          <div>
            <div>
              <span className="text-[#000] font-bold">Bid placed by</span>
              <span className="group relative">
                <a className="cursor-pointer ml-1 z-0">@jeffexcell</a>
                <UserProfileCard />
              </span>
            </div>
            <p className="font-normal">Jan 17, 2022 at 3:47am</p>
          </div>
          <h3 className="text-xl font-bold text-[#000]">0.50 ETH</h3>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 cursor-pointer stroke-stone-500 hover:stroke-stone-900 duration-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </div>
      </div>
    </>
  );
}

export default UserData;
